import { UserRole } from '@academia-apolo/shared-types';
import { ROUTES } from '@/lib/constants';
/**
 * Allowed roles per panel area. Single source of truth shared by the router
 * guards and their tests; must stay in sync with layouts/config/navigation.ts.
 *
 * `staff` covers the routes a director reaches under their dual role (ADR-009):
 * the blog and the professor "Mis clases" page.
 */
export const AREA_ROLES = {
    director: [UserRole.DIRECTOR],
    professor: [UserRole.PROFESSOR],
    staff: [UserRole.DIRECTOR, UserRole.PROFESSOR],
    student: [UserRole.STUDENT],
    support: [UserRole.SUPPORT],
};
/** Landing route for a given role (used as the redirect target on mismatch). */
export function homeForRole(role) {
    switch (role) {
        case UserRole.DIRECTOR:
            return ROUTES.DIRECTOR_HOME;
        case UserRole.PROFESSOR:
            return ROUTES.PROFESSOR_HOME;
        case UserRole.STUDENT:
            return ROUTES.STUDENT_DASHBOARD;
        case UserRole.SUPPORT:
            return ROUTES.SUPPORT_INBOX;
        default:
            return ROUTES.LOGIN;
    }
}
/**
 * Pure decision: may `user` enter an area restricted to `allowed` roles?
 * Returns where to bounce them when not. Kept side-effect free so the router
 * guard and the unit tests exercise the exact same logic.
 */
export function resolveRoleAccess(user, allowed) {
    if (!user) {
        return { allow: false, redirectTo: ROUTES.LOGIN };
    }
    if (!allowed.includes(user.role)) {
        return { allow: false, redirectTo: homeForRole(user.role) };
    }
    return { allow: true };
}
//# sourceMappingURL=role-access.js.map